import { InjectionToken } from '@angular/core';

import { API_OPTIONS } from '../types/api-options';

export const API_OPTIONS_TOKEN = new InjectionToken<API_OPTIONS>('API_OPTIONS');
